"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = require("./styled");
require("./sunny.css");
var Sunny = function (_a) {
    var children = _a.children;
    (0, react_1.useEffect)(function () {
        addSunshine();
    }, []);
    var getRandom = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    var addSunshine = function () {
        var canvas = document.querySelector("canvas");
        var context = canvas === null || canvas === void 0 ? void 0 : canvas.getContext("2d"), stars = 500, colorrange = [0, 60, 240];
        appendCircle();
        if (canvas && context) {
            context.canvas.width = window.innerWidth + 300;
            context.canvas.height = window.innerHeight + 300;
            for (var i = 0; i < stars; i++) {
                var x = Math.random() * canvas.offsetWidth, y = Math.random() * canvas.offsetHeight, radius = Math.random() * 1.5, hue = colorrange[getRandom(0, colorrange.length - 1)], sat = getRandom(50, 100);
                context.beginPath();
                context.arc(x, y, radius, 0, 360);
                context.fillStyle = "hsl(" + hue + ", " + sat + "%, 88%)";
                context.fill();
            }
        }
    };
    var count = 0;
    var appendCircle = function () {
        var circles = document.querySelector("#circles");
        var circle = document.createElement("div");
        circle.classList.add("circle");
        circles === null || circles === void 0 ? void 0 : circles.append(circle);
        while (count < 200) {
            window.requestAnimationFrame(appendCircle);
            count++;
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        react_1.default.createElement(styled_1.Sunshine, null),
        react_1.default.createElement("div", null,
            react_1.default.createElement(styled_1.Colorizer1, null),
            react_1.default.createElement(styled_1.Colorizer2, null),
            react_1.default.createElement(styled_1.Colorizer3, null),
            react_1.default.createElement(styled_1.Colorizer4, null),
            react_1.default.createElement("div", { id: "circles" }))));
};
exports.default = Sunny;
